// MedalCounter.js
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { moneyMaker } from '../utils';
import TariaGold from '../svg/TariaGold';
import { ReactComponent as Close } from '../svg/close.svg';
import { ReactComponent as TariaGold2 } from '../svg/Taria_Gold.svg';



const MoneyCounter = ({ idPerso, groupe, token }) => {
  const ip = process.env.REACT_APP_IP;
  const [gold, setGold] = useState(0);
  const [silver, setSilver] = useState(0);
  const [bronze, setBronze] = useState(0);
  const [idVar, setIdVar] = useState(0);
  const [nomThunes, setNomThunes] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [height, setHeight] = useState('0px');
  const contentRef = useRef(null);
  const toggleCollapse = () => {
    setIsOpen(!isOpen);
  };
  useEffect(() => {
    setHeight(isOpen ? `${contentRef.current.scrollHeight}px` : '0px');
  }, [isOpen]);

  useEffect(() => {
    fetchThunes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idPerso]);

  const fetchThunes = async () => {
    try {
      const response = await axios.get(`${ip}/thunes/${groupe}/${idPerso}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
    });
      const valeur = response.data[0].valeur;
      const money = moneyMaker(valeur);
      setGold(money.or);
      setSilver(money.argent);
      setBronze(money.bronze);
      setIdVar(response.data[0].idVariable);
      if (groupe == "groupe") {
        setHeight("none")
        setNomThunes(response.data[0].nom)
      }
    } catch (error) {
      console.error('Une erreur s\'est produite lors de la récupération du personnage :', error);
    }
  };

  const handleUpdate = async () => {
    try {
      const totalValue = gold * 100 + silver * 10 + bronze;
      const response = await axios.put(`${ip}/thunes/${idVar}`, { valeur: totalValue },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          } 
    });
    } catch (error) {
      console.error('Une erreur s\'est produite lors de la mise à jour des données :', error);
    }
  };

  const incrementBronze = () => {
    setBronze(prevBronze => {
      const newBronze = prevBronze + 1;
      if (newBronze % 10 === 0) {
        incrementSilver();
        return 0;
      }
      return newBronze;
    });
  };

  const decrementBronze = () => {
    setBronze(prevBronze => {
      if (prevBronze > 0) {
        return prevBronze - 1;
      } else if (silver > 0) {
        decrementSilver();
        return 9;
      } else if (gold > 0) {
        decrementGold();
        setSilver(9);
        return 9;
      }
      return prevBronze;
    });
  };

  const incrementSilver = () => {
    setSilver(prevSilver => {
      const newSilver = prevSilver + 1;
      if (newSilver % 10 === 0) {
        incrementGold();
        return 0;
      }
      return newSilver;
    });
  };

  const decrementSilver = () => {
    setSilver(prevSilver => {
      if (prevSilver > 0) {
        return prevSilver - 1;
      } else if (gold > 0) {
        decrementGold();
        return 9;
      }
      return prevSilver;
    });
  };

  const incrementGold = () => {
    setGold(prevGold => prevGold + 1);
  };

  const decrementGold = () => {
    setGold(prevGold => (prevGold > 0 ? prevGold - 1 : prevGold));
  };

  useEffect(() => {
    handleUpdate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gold, silver, bronze]);

  const variable = {
    gold: { increment: incrementGold, decrement: decrementGold, value: gold },
    silver: { increment: incrementSilver, decrement: decrementSilver, value: silver },
    bronze: { increment: incrementBronze, decrement: decrementBronze, value: bronze },
  };

  const inputUpdateb = (type, valeur) => {
    switch (type) {
      case "bronze":
        setBronze(valeur)
        break;
      case "silver":
        setSilver(valeur)
        break;
      case "gold":
        setGold(valeur)
        break;
      default:
      // code block
    }
  }


  return (
    <div>
      {groupe == "groupe" &&
        <div className='margin-bot1-5  '>
          <span className='titre-groupe'>{nomThunes}
          </span>
        </div>

      }
      {
        <div className={`containerMoney ${isOpen ? 'open' : 'closed'}`} ref={contentRef}
          style={{
            maxHeight: height,
          }}>
          {Object.entries(variable).map(([key, value]) => (
            <div key={key} className="colonneMoney">
              <div className="adjustable-controlMoney">
                <button className={" buttonMoney " + key} onClick={value.decrement}>-</button>
                <input
                  id={key}
                  type="number"
                  className="width_2em centerText "
                  value={value?.value || 0}
                  onChange={e => inputUpdateb(e.target.id, e.target.value)}
                  onFocus={e => e.target.select()}

                />
                <button className={"buttonMoney " + key} onClick={value.increment}>+</button>
              </div>
            </div>
          ))}
          <div className={`money ${isOpen ? 'open' : 'closed'} ${groupe != "solo" ? 'hide' : ''}`} onClick={toggleCollapse}>
            {!isOpen && <TariaGold2 className='h0-6em svg-closed' />}
            {isOpen && <Close className='h0-6em heigh_1em' />}
          </div>
        </div>
      }
    </div>

  );
};

export default MoneyCounter;
